import { FetchContext } from '../fetch-context';
import { OperationName, OperationStatus, OperationStatusType } from '../../models';
import { responseErrorHandler } from '../response-error-handler';

export const getOperationStatus: (
  fetchContext: FetchContext,
  operationName: OperationName,
  operationStatus?: OperationStatusType,
  accessToken?: string,
) => Promise<OperationStatus> = (fetchContext, operationName, operationStatus, accessToken) => {
  const params = new URLSearchParams();
  if (operationName) params.append('operationName', operationName);
  if (operationStatus) params.append('operationStatus', operationStatus);

  return fetch(`${fetchContext.baseUrl}/api/admin/operations/status${params.size > 0 ? `?${params}` : ''}`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<OperationStatus>(fetchContext.errorStore, response, 'get bulk export nominations status'));
};
